import { motion } from "framer-motion";

export const TeamIntro = () => {
  return (
    <section
      id="equipe-intro"
      data-testid="team-intro-section"
      className="py-20 md:py-28 relative overflow-hidden"
    >
      <div className="container-xl">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="lg:col-span-7 relative"
          >
            <div className="relative aspect-[5/4] rounded-[2rem] overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_smile-lagavotte/artifacts/fm4qvi7i_PSTK4172.JPG"
                alt="L'équipe du Cabinet Dentaire La Gavotte"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#2D241E]/30 via-transparent to-transparent" />
            </div>
            {/* Decorative accent */}
            <div className="hidden md:block absolute -bottom-6 -right-6 w-40 h-40 rounded-full border border-[#BE6C42]/30 pointer-events-none" />
          </motion.div>

          {/* Text */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{
              duration: 0.9,
              delay: 0.15,
              ease: [0.16, 1, 0.3, 1],
            }}
            className="lg:col-span-5"
          >
            <span className="overline">Notre philosophie</span>
            <h2 className="h2 text-3xl sm:text-4xl lg:text-5xl mt-5 leading-[1.08]">
              Une équipe souriante,
              <br />
              <span className="italic text-[#BE6C42] font-light">
                attentive et engagée
              </span>
              <br />
              pour vous accompagner au quotidien.
            </h2>
            <div className="mt-8 pl-6 border-l-2 border-[#BE6C42]">
              <p className="body-text text-base sm:text-lg">
                Ici, nous prenons soin de votre sourire, mais aussi de votre
                confort.
              </p>
            </div>

            {/* Signature slogan */}
            <div className="mt-10 pt-8 border-t border-[#E8DED5]">
              <div className="overline mb-2">Notre engagement</div>
              <div className="font-serif text-2xl md:text-3xl text-[#2D241E] italic">
                « Votre sourire,{" "}
                <span className="text-[#BE6C42] not-italic font-medium">
                  notre priorité.
                </span>{" "}
                »
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default TeamIntro;
